// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3rIf_","selects":"Documents_selects__hJt0c"};